import { trackCHEvents } from "@analytics/utils/trackEvents";
import { compact } from "@utils/fn-utils";

export const trackPageLoad = (data) => {
  const payload = compact({
    screenName: "news_details",
    ...data
  });
  trackCHEvents(`news_details_page_load`, payload);
};
